import React, { ReactElement, useState } from 'react'
import styled from 'styled-components'

const Options = styled.ul`
  display: flex;
  padding: 0;
  margin: 0;
  align-items: center;

  li {
    display: inline-block;
  }
`

export interface TabListProps {
  selectedTabIndex?: number
  /** This prop is deprecated, but still here for backwards compatibility */
  shouldDrawSeparator?: boolean
  children: React.ReactElement[]
  onTabSelected?: (tabOption: number) => void
  shouldSelectTab?: (tabOption: number) => boolean
  className?: string
}

const TabList = ({
  children,
  selectedTabIndex = 0,
  onTabSelected,
  shouldSelectTab = () => true,
  className,
}: TabListProps) => {
  const tabs = React.Children.toArray(children)
  const [selectedTab, setSelectedTab] = useState(selectedTabIndex)

  return (
    <Options className={className}>
      {tabs.map((tab, index) => {
        return React.cloneElement(tab as ReactElement, {
          onTabSelected: () => {
            if (!shouldSelectTab(index)) return

            setSelectedTab(index)
            onTabSelected?.(index)
          },
          selected: selectedTab === index,
        })
      })}
    </Options>
  )
}

TabList.tabType = 'TabList'

export default TabList
